import { type QueryKey, useQuery } from '@tanstack/react-query';

import type { LivestreamResponse } from '@cobliteam/common-types';

import { LivestreamRequester } from '@cobliteam/api-lib';

import { Environment } from '@cobliteam/react-environments';

const env = Environment.getInstance().getEnvironment();
const livestreamRequester = new LivestreamRequester({
  host: env.apiHost,
});
const QUERY_KEY: QueryKey = ['CAMERA-LIVESTREAM'];

const useDeviceLivestream = () => {
  const getDeviceLivestream = (deviceId: string) => {
    return useQuery<LivestreamResponse>({
      queryKey: [...QUERY_KEY, deviceId],
      queryFn: () => livestreamRequester.getLivestream({ deviceId }),
    });
  };

  return {
    getDeviceLivestream,
  };
};

export default useDeviceLivestream;
